module.exports = __webpack_public_path__ + "static/media/user_Profile_Big.c5b36081.svg";